import {createStore ,  applyMiddleware} from 'redux'
import CombineReducers from '../Reducers/CombineReducer';
import {thunk }from 'redux-thunk';


const persisted_state  = sessionStorage.getItem('reduxStore') ? JSON.parse(sessionStorage.getItem('reduxStore') ) : {};



const enhancer  = applyMiddleware(thunk)


const store  = createStore(
    CombineReducers,
    persisted_state,
    enhancer
)


export default store




